// Provides a stable portal root to avoid DOM mismatch or double-removal issues.
// Creates <div id="portal-root"> once and reuses it for all portals.
export function getPortalRoot(): HTMLElement {
  if (typeof document === 'undefined') {
    // SSR guard
    return {} as HTMLElement;
  }
  const existing = document.getElementById('portal-root');
  if (existing) return existing;
  const el = document.createElement('div');
  el.id = 'portal-root';
  document.body.appendChild(el);
  return el;
}


